import { H3 } from '@h3/types';
import * as Api from '../../api';
import { BaseModule } from './base';

export default class WorkflowState extends BaseModule {
    private _todoCount?: H3.FlowCenter.Response.TodoCount;

    private _loadTodoCountPromise?: Promise<boolean>;

    private _abort?: () => void;

    get todoCount() {
        return (
            this._todoCount ?? {
                unFinishedCount: 0,
                unReadCount: 0,
                myInstanceCount: 0,
            }
        );
    }

    /**
     * 加载待办数量
     * @params timeout 是否延时请求（延时请求时会取消现有所有请求并在5秒后重新请求）
     * @returns 是否加载成功
     */
    async loadTodoCount(timeout = false) {
        // 延时请求，取消现有所有请求并在5秒后重新请求
        if (timeout) {
            const TIMESTAMP = 5000;
            this._abort?.();
            this._loadTodoCountPromise = new Promise((resolve) => {
                const timer = setTimeout(() => {
                    const { request, abort } = this._getTodoCount();
                    this._abort = abort;
                    resolve(request);
                }, TIMESTAMP);
                this._abort = () => {
                    clearTimeout(timer);
                };
            });
            return this._loadTodoCountPromise;
        }

        // 已经请求过了，不再请求
        if (this._todoCount) {
            return true;
        }

        // 正在请求中，返回该请求
        if (this._loadTodoCountPromise) {
            return this._loadTodoCountPromise;
        }

        // 没有请求，发起请求
        const { request, abort } = this._getTodoCount();
        this._abort = abort;
        this._loadTodoCountPromise = request;

        return this._loadTodoCountPromise;
    }

    afterSwitchEngine() {
        this._todoCount = void 0;
        this.loadTodoCount();
    }

    private _getTodoCount() {
        const abortController = new AbortController();
        const request = Api.Task.getTodoCount({ signal: abortController.signal })
            .then((res) => {
                if (!res.successful) {
                    return false;
                }
                this._todoCount = res.returnData;
                return true;
            })
            .catch(() => {
                return false;
            })
            .finally(() => {
                this._loadTodoCountPromise = void 0;
                this._abort = void 0;
            });
        return {
            request,
            abort: () => {
                abortController.abort();
            },
        };
    }
}
